export default {
  default: {
    data: 'Data',
    shortcode: 'Shortcode',
    value: 'Value',
  },
}
